import { Controller } from "@hotwired/stimulus"

// The toolbar's funnel popover with two single-select sections (Type / Priority).
// Choosing an option writes its section's hidden field and submits the toolbar form (a
// Turbo-Frame GET), so the list re-renders with no reload. Unlike the plain dropdown, the
// popover STAYS OPEN so filters can be stacked; it closes on outside-click or Escape.
export default class extends Controller {
  static targets = ["menu", "field", "dot"]

  connect() {
    this.closeOnOutside = this.closeOnOutside.bind(this)
    this.closeOnEscape = this.closeOnEscape.bind(this)
  }

  disconnect() {
    this.removeListeners()
  }

  toggle() {
    this.menuTarget.hidden ? this.open() : this.close()
  }

  open() {
    this.menuTarget.hidden = false
    this.button.setAttribute("aria-expanded", "true")
    document.addEventListener("click", this.closeOnOutside)
    document.addEventListener("keydown", this.closeOnEscape)
  }

  close() {
    this.menuTarget.hidden = true
    this.button.setAttribute("aria-expanded", "false")
    this.removeListeners()
  }

  select(event) {
    const chosen = event.currentTarget
    // Move the checked state within this option's own section only.
    chosen.closest("[role='group']").querySelectorAll("[role='menuitemradio']").forEach((option) => {
      option.setAttribute("aria-checked", option === chosen ? "true" : "false")
    })
    this.fieldFor(event.params.field).value = event.params.value
    this.refreshDot()
    this.element.closest("form").requestSubmit()
  }

  fieldFor(name) {
    return this.fieldTargets.find((field) => field.dataset.field === name)
  }

  refreshDot() {
    if (!this.hasDotTarget) return
    const active = this.fieldFor("type").value !== "" ||
                   this.fieldFor("priority").value !== ""
    this.dotTarget.classList.toggle("is-active", active)
  }

  closeOnOutside(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
      this.button.focus()
    }
  }

  removeListeners() {
    document.removeEventListener("click", this.closeOnOutside)
    document.removeEventListener("keydown", this.closeOnEscape)
  }

  get button() {
    return this.element.querySelector("[aria-haspopup]")
  }
}
